// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'
import qs from "qs"
import ElementUI from 'element-ui';
import axios from 'axios'
import validator from '@/utils/validator'
import utils from '@/utils'
import request from '@/api/request'
import md5 from 'js-md5';
// import 'babel-polyfill'
import '@/assets/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css';
// import 'common/stylus/index.styl' 
Vue.prototype.validator = validator
Vue.prototype.validatenull = utils.validatenull
Vue.prototype.recover = utils.recover
Vue.prototype.$axios = axios
Vue.prototype.$events = new Vue()
Vue.prototype.$md5 = md5;
Vue.prototype.$qs = md5;
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(request);

import store from './store/index.js'
Vue.prototype.$store = store



import "animate.css"
import "wowjs/css/libs/animate.css" // 巨坑... 此地方要引入两个css
import wow from 'wowjs'
Vue.prototype.$wow = wow


import VueAwesomeSwiper from 'vue-awesome-swiper';
console.log("vueAwesomSwiper",VueAwesomeSwiper)
import 'swiper/dist/css/swiper.css';
Vue.use(VueAwesomeSwiper);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js